/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react'
import * as S from './styles'
import { PaymentMethods } from '../../../Models'

export const MethodUnavailableModal = ({
  closeModal,
  method,
}: {
  closeModal: () => void
  method: PaymentMethods
}) => {
  function situationText() {
    if (method.tag === 'CREDIT') {
      if (method.rule) {
        if (method.rule.type === 'MIN') {
          return `O valor mínimo para pagamentos com cartão de crédito é R$${method.rule.ref.toLocaleString(
            'pt-BR',
            {
              minimumFractionDigits: 2,
            }
          )}. Aproveite a comodidade de pagar custas com facilidade!`
        }
        if (method.rule.type === 'MAX') {
          return `Os pagamentos via ${
            method.name
          } estão disponíveis apenas para valores até R$ ${method.rule.ref.toLocaleString(
            'pt-BR',
            {
              minimumFractionDigits: 2,
            }
          )}. Você pode remover débitos ou escolher outra forma de pagamento.`
        }
      }
    }
    if (method.rule) {
      if (method.rule.type === 'MIN') {
        return `Os pagamentos por ${
          method.name
        } estão disponíveis para valores acima de R$ ${method.rule.ref.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )}. Você pode adicionar mais débitos ou escolher outra forma de pagamento.`
      }
      if (method.rule.type === 'MAX') {
        return `Os pagamentos via ${
          method.name
        } estão disponíveis apenas para valores até R$ ${method.rule.ref.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )}. Você pode remover débitos ou escolher outra forma de pagamento.`
      }
    }

    return ''
  }

  return (
    <S.ModalContainer
      onClick={() => {
        closeModal()
      }}
    >
      <S.ModalDetail
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <div className="modal_detail_head">
          <p className="modal_detail_head_label">{`Pagamento por ${method.name} indisponível`}</p>
        </div>
        <p className="modal_detail_label">{situationText()}</p>
        <S.ModalButton
          onClick={() => {
            closeModal()
          }}
        >
          Ok, Entendi
        </S.ModalButton>
      </S.ModalDetail>
    </S.ModalContainer>
  )
}
